import VueAPIManager from "@payamnaghdy/vue-api-manager";
import { parseError } from "./utils/parsers";
// If this is not your store path change this import
import store from "../store/index";

function getAuthorizationToken() {
  // You should write a getter for the token or change the return value
  return store.getters.getAccessToken;
}
const parseResponse = response => {
  return response.data.response;
};

const APIRoutes = {
  host: store.getters.getServerAddress,
  authorizationHeaderPrefix: "", // The module automatically puts a space after the prefix
  rootURL: "api/v1/dashboard/",
  headers: {
    "Content-Type": "application/json"
  }, // Here you can set global headers
  apis: {
    ping: {
      method: "GET",
      path: "ping/",
      requiresAuth: false
    },
    getLogs: {
      method: "GET",
      path: "get-logs/",
      requiresAuth: true
    },
    getUsers: {
      method: "GET",
      path: "get-application-users-list/",
      requiresAuth: true
    },
    getUserDetails: {
      method: "GET",
      path: "get-application-user-details/",
      requiresAuth: true
    },
    getUserDevices: {
      method: "GET",
      path: "get-user-devices/",
      requiresAuth: true
    },
    createUser: {
      method: "POST",
      path: "create-application_user/",
      requiresAuth: true
    },
    enrollUser: {
      method: "POST",
      path: "enroll-application-user/",
      requiresAuth: true
    },
    deleteUser: {
      method: "DELETE",
      path: "edit-application-user/",
      requiresAuth: true
    },
    editDevice: {
      method: "POST",
      path: "edit-device/",
      requiresAuth: true
    },
    createDevice: {
      method: "POST",
      path: "create-new-device/",
      requiresAuth: true
    },
    getAvailableHardwareDevices: {
      method: "GET",
      path: "available-hardware-devices/",
      requiresAuth: true,
    },
    assignHardwareDevice: {
      method: "POST",
      path: "assign-hardware-device/",
      requiresAuth: true,
    },
    getPolicies: {
      method: "GET",
      path: "policy/",
      requiresAuth: true,
    },
    setPolicy: {
      method: "POST",
      path: "policy/",
      requiresAuth: true,
    },
    deletePolicy: {
      method: "DELETE",
      path: "policy/",
      requiresAuth: true,
    },
    patchPolicy: {
      method: "PATCH",
      path: "policy/",
      requiresAuth: true,
    },
    enableDisableMFASettings: {
      method: "PATCH",
      path: "policy/",
      requiresAuth: true
    },
    getApplications: {
      method: "GET",
      path: "get-applications/",
      requiresAuth: true,
    },
    getApplicationDetails: {
      method: "GET",
      path: "get-application-details/",
      requiresAuth: true,
    },
    getApplicationSkey: {
      method: "GET",
      path: "get-application-key/",
      requiresAuth: true,
    },
    deleteApplication: {
      method: "DELETE",
      path: "edit-application/",
      requiresAuth: true,
    },
    editApplication: {
      method: "POST",
      path: "edit-application/",
      requiresAuth: true,
    },
    changePassword: {
      method: "POST",
      path: "change-password/",
      requiresAuth: true,
    },
    changePasswordNoAuth: {
      method: "POST",
      path: "change-password/",
      requiresAuth: false,
    },
    getAuditLogs: {
      method: "GET",
      path: "admin-logs/",
      requiresAuth: true
    },
    applyServerConfiguration: {
      method: "POST",
      path: "server-configuration/apply/",
      requiresAuth: true
    },
    getServerConfigurationState: {
      method: "GET",
      path: "server-configuration/state/",
      requiresAuth: true
    },
    getServerConfiguration: {
      method: "GET",
      path: "server-configuration/",
      requiresAuth: true
    },
    setServerConfiguration: {
      method: "POST",
      path: "server-configuration/",
      requiresAuth: true
    },
    deleteServerConfiguration: {
      method: "DELETE",
      path: "server-configuration/",
      requiresAuth: true
    },
    dashboardStats: {
      method: "GET",
      path: "get-dashboard-stats/",
      requiresAuth: true
    },
    dashboardCharts: {
      method: "GET",
      path: "get-dashboard-charts/",
      requiresAuth: true
    },
    getVersion: {
      method: "GET",
      path: "ping/",
      requiresAuth: true
    },
    getAdmins: {
      method: "GET",
      path: "admin-management/",
      requiresAuth: true,
    },
    deleteAdmin: {
      method: "DELETE",
      path: "admin-management/",
      requiresAuth: true,
    },
    createAdmin: {
      method: "POST",
      path: "admin-management/",
      requiresAuth: true,
    },
    patchAdmin: {
      method: "PATCH",
      path: "admin-management/",
      requiresAuth: true,
    },
    getNotifications: {
      method: "GET",
      path: "notifications/",
      requiresAuth: true,
    },
    markNotificationAsRead: {
      method: "DELETE",
      path: "notifications/",
      requiresAuth: true,
    },
    whoAmI: {
      method: "GET",
      path: "who-am-i/",
      requiresAuth: true,
    },
    getFailureAttempts: {
      method: "GET",
      path: "admin-attempts/",
      requiresAuth: true,
    },
    deleteFailureAttempts: {
      method: "DELETE",
      path: "admin-attempts/",
      requiresAuth: true,
    },
    setLicense: {
      method: "POST",
      path: "license-management/",
      requiresAuth: true,
    },
    addHardwareDevice: {
      method: "POST",
      path: "add-hardware-device/",
      requiresAuth: true,
    },
    getHardwareDevicesList: {
      method: "GET",
      path: "hardware-devices-list/",
      requiresAuth: true,
    },
    registerFidoToken: {
      method: "POST",
      path: "../fido/register/",
      requiresAuth: false,
    },

    // Login
    login: {
      method: "POST",
      path: "../../../api-token-auth/", // TODO: Should change apiManager to accept absolute paths and remove `..`
      requiresAuth: false,
    },
    refreshToken: {
      method: "POST",
      path: "../../../api-token-refresh/", // TODO: Should change apiManager to accept absolute paths and remove `..`
      requiresAuth: false,
    },

    // Logout
    logout: {
      method: "POST",
      path: "../../../api-token-logout/", // TODO: Should change apiManager to accept absolute paths and remove `..`
      requiresAuth: true,
    },
  },
};
const apiManager = new VueAPIManager(APIRoutes);

apiManager.setAuthorizationHeader(getAuthorizationToken);
apiManager.setResponseParser(parseResponse);
apiManager.setHttpErrorParser(parseError);

import axios from "axios";
import { refreshAccessToken, forceLogout } from "@/utils/authStorageManager";

let isRefreshing = false;
const refreshQueue = [];

const processQueue = (error, token) => {
  refreshQueue.forEach(p => {
    error ? p.reject(error) : p.resolve(token);
  });
  refreshQueue.length = 0;
};

axios.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (originalRequest.url.includes("/api-token-refresh")) {
      return Promise.reject(error);
    }

    if (error?.response?.status === 401 && !originalRequest._retry) {
      if (window.location.hash.includes('#/login')) {
        return Promise.reject(error)
      }
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          refreshQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers["Authorization"] = token;
          return axios(originalRequest);
        });
      }

      isRefreshing = true;
      return new Promise(async (resolve, reject) => {
        try {
          await refreshAccessToken();
          const newToken = store.getters.getAccessToken;

          processQueue(null, newToken);
          originalRequest.headers["Authorization"] = newToken;
          resolve(axios(originalRequest));
        } catch (err) {
          processQueue(err, null);
          forceLogout();
          reject(err);
        } finally {
          isRefreshing = false;
        }
      });
    }

    return Promise.reject(error);
  }
);

export default apiManager;
